export enum TableAction {
    CREATE = 'create',     
    REFRESH = 'refresh',     
  }